// ProfesorGuard: protege rutas /profesor/*. Paralelo a AdminGuard.
//
//   - Mientras AuthContext está rehidratando: spinner.
//   - Si no logado: redirige a /login con ?next= para volver tras éxito.
//   - Si logado pero rol != 'profesor': pantalla "Sin acceso".
//
// Reusa estilos .admin-loading y .admin-sin-acceso del CSS del admin
// (decisión 4 SS7.2: mismo diseño que admin).

import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2, ShieldOff } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function ProfesorGuard({ children }) {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="admin-loading">
        <Loader2 size={28} className="spin" strokeWidth={1.5} />
        <span>{t('admin.cargando')}</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (user?.rol !== 'profesor') {
    return (
      <div className="admin-sin-acceso">
        <ShieldOff size={48} strokeWidth={1.25} />
        <h1>{t('admin.sin_acceso_titulo')}</h1>
        <p>{t('admin.sin_acceso_sub')}</p>
        <a href="/" className="btn-primary">{t('admin.volver_inicio')}</a>
      </div>
    );
  }

  return children;
}
